export class ArquivoUploadParcela {
    tipo: string;
    documentoBase64: string;
    parcelaId: number;
    transferenciaId: number;
    fileName: string;
}
